// src/Component/Master/header.jsx
import React, { useEffect, useState } from "react";
import Logo from "../../Assets/img/Logo.png";
import { GetBlogsTypes } from "../../Services/UserDataService";
import { useNavigate } from "react-router-dom";

const Header = () => {

	const [blogTypes, setBlogTypes] = useState([]);
	const [isLoadingBlogTypes, setIsLoadingBlogTypes] = useState(false);
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

	const navigate = useNavigate();

	useEffect(() => {
		let mounted = true;

		const fetchBlogTypes = async () => {
			setIsLoadingBlogTypes(true);
			try {
				const res = await GetBlogsTypes();
				const items = res?.blogsTypes ?? [];
				if (mounted) setBlogTypes(items);
			} catch (err) {
				// keep blogTypes as [] so fallback entries will render
			} finally {
				if (mounted) setIsLoadingBlogTypes(false);
			}
		};

		fetchBlogTypes();
		return () => {
			mounted = false;
		};
	}, []);


	const goToSection = (e, id) => {
		e.preventDefault();
		navigate("/", { state: { scrollTo: id } });
	};

	return (
		<div id="app" className="min-h-full">
			<header
				className="sticky top-0 z-50 shadow-md"
				style={{ backgroundColor: "#FFFFFF" }}
			>
				<div className="max-w-7xl mx-auto px-6 py-4">
					<div className="flex items-center justify-between">
						<div className="flex items-center gap-12">
							<h1
								id="site-name"
								className="text-3xl font-bold"
								style={{ color: "#FF8C00" }}
							>
								<img src={Logo} width={200} alt="logo" />
							</h1>

							<nav className="hidden lg:flex gap-8">
								<a
									href="/"
									id="nav-home"
									className="nav-link font-medium"
									style={{ color: "#374151" }}
								>
									Home
								</a>

								<a
									href="/about"
									id="nav-about"
									className="nav-link font-medium"
									style={{ color: "#374151" }}
								>
									About Us
								</a>

								{/* Our Offerings Dropdown */}
								<div className="relative group">

									<a
										className="nav-link font-medium inline-flex items-center gap-1"
										style={{ color: "#374151" }}
										onClick={(e) => goToSection(e, "offerings")} href="/#offerings"
									>Our Offerings
									</a>
								</div>

								<a
									href="/contact"
									id="nav-contact"
									className="nav-link font-medium"
									style={{ color: "#374151" }}
								>
									Contact
								</a>
							</nav>
						</div>

						<div className="flex items-center gap-4">
							<a
								href="/Auth"
								id="login-button"
								className="flex items-center gap-2 px-3 py-3 rounded-full font-semibold btn-hover"
								style={{ backgroundColor: "#FF8C00", color: "#FFFFFF" }}
							>
								<span className="text-1xl">👤</span>
							</a>

							<button
								id="mobile-menu-btn"
								type="button"
								className="lg:hidden text-3xl"
								style={{ color: "#374151" }}
								aria-label={isMobileMenuOpen ? "Close mobile menu" : "Open mobile menu"}
								aria-expanded={isMobileMenuOpen}
								aria-controls="mobile-menu"
								onClick={() => setIsMobileMenuOpen((prev) => !prev)}
							>
								{isMobileMenuOpen ? "✕" : "☰"}
							</button>
						</div>
					</div>

					{/* Mobile nav (hidden by default) */}
					<nav id="mobile-menu" className={`lg:hidden mt-4 pb-4 ${isMobileMenuOpen ? "block" : "hidden"}`}>
						<div className="flex flex-col gap-4">
							<a
								href="#home"
								className="font-medium py-2 border-b"
								style={{ color: "#374151", borderColor: "#E5E7EB" }}
							>
								Home
							</a>
							<a
								href="#about"
								className="font-medium py-2 border-b"
								style={{ color: "#374151", borderColor: "#E5E7EB" }}
							>
								About Us
							</a>
							<a
								href="#offerings"
								className="font-medium py-2 border-b"
								style={{ color: "#374151", borderColor: "#E5E7EB" }}
							>
								Our Offerings
							</a>
							<a
								href="#contact"
								className="font-medium py-2"
								style={{ color: "#374151" }}
							>
								Contact
							</a>
						</div>
					</nav>
				</div>
			</header>
		</div>
	);
};

export default Header;
